import { useEffect, useRef } from 'react';
import { useDeviceStore } from '../store/deviceStore';
import { debounce } from '../util/debounce';

/**
 * 디바이스 타입을 자동으로 감지하고 리사이즈 이벤트를 처리하는 훅
 */
export const useDeviceDetection = () => {
  const { detectDevice } = useDeviceStore();
  const debouncedDetectDeviceRef = useRef<(() => void) | null>(null);

  // 1. 디바운스 함수가 안정적으로 유지됨
  // 2. 250ms 후에만 detectDevice 호출됨
  // 3. 불필요한 상태 업데이트 방지됨
  useEffect(() => {
    // 디바운스된 함수를 ref에 저장 (한 번만 생성)
    if (!debouncedDetectDeviceRef.current) {
      debouncedDetectDeviceRef.current = debounce(() => {
        detectDevice();
      }, 250);
    }

    // 초기 디바이스 감지
    detectDevice();

    // 이벤트 리스너 등록
    const handleResize = debouncedDetectDeviceRef.current;
    window.addEventListener('resize', handleResize);

    // 클린업 함수
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [detectDevice]);
}; 